import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect } from "react-router";

import { Loading } from "../../components/loading";
import { Navmenu } from "../../components/navmenu";
import { RecordsPanel } from "../../components/records-panel";
import { Record } from "../../components/record";

import { getFilesRequest } from "../../store/files/actions";
import { filterRecords } from "../../utils/filter-records";

export const Files = () => {
    const dispatch = useDispatch();
    const [searchValue, setSearchValue] = useState("");
    useEffect(() => {
        dispatch(getFilesRequest());
    }, [dispatch]);

    const { filesList, isLoading } = useSelector((state) => state.files);

    const filteredRecords = filterRecords(filesList, searchValue, ["url"]);

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <div className="page">
                    <Navmenu />
                    <main className="main">
                        <RecordsPanel
                            searchValue={searchValue}
                            setSearchValue={setSearchValue}
                            link="/file/create"
                        />
                        {filteredRecords ? (
                            filteredRecords.map((file, idx) => (
                                <Record
                                    title={file.url}
                                    id={file.id}
                                    onClick={() => (
                                        <Redirect to={`/file/${file.name}`} />
                                    )}
                                    link="file"
                                    key={idx.toString()}
                                />
                            ))
                        ) : (
                            <p className="not__found">Records not found...</p>
                        )}
                    </main>
                </div>
            )}
        </>
    );
};
